<template>
    <div>
        <div class="card" v-if="pageWidth>1000">
            <div class="ibos">
                <div class="text animate__animated animate__fadeInLeft">
                    <p class="title">07 <span>星筑IBOS系统</span></p>
                    <p>
                        星筑IBOS系统是一款全面的智慧建筑管理系统，为现代化园区和建筑提供高效、智能的综合管理解决方案。通过集成智能照明、安防监控、智慧停车、状态监测、门禁管理、智慧能耗管理等功能，IBOS系统使建筑管理者能够实时监控和智能化管理建筑设施。借助先进的物联网技术和大数据分析，该系统提供全面的实时监测、预警和优化调节能力，助力建筑实现更高效、更安全、更可持续的运营管理。</p>
                </div>
                <div class="image animate__animated animate__fadeInRight">
                    <img src="../../../assets/solution/ibos/ibos.png" alt="">
                    <p>IBOS驾驶舱页面</p>
                </div>
            </div>
            <div class="features">
                <div class="title">
                    <p>产品特点</p>
                    <p>PRODUCT FEATURES</p>
                </div>
                <div class="main">
                    <div class="top">
                        <div>
                            <img src="../../../assets/solution/ibos/totality.png" alt="">
                            <p>全面性</p>
                            <p>IBOS系统涵盖了智能照明、安防监控、智慧停车、状态监测、门禁管理、智慧能耗管理等多个功能，提供综合的建筑物管理解决方案。
                            </p>
                        </div>
                        <div>
                            <img src="../../../assets/solution/ibos/intelligent.png" alt="">
                            <p>智能化</p>
                            <p>借助物联网技术和大数据分析，IBOS系统实现了实时监测、预警和优化调节能力，使建筑管理更加智能化。
                            </p>
                        </div>
                        <div>
                            <img src="../../../assets/solution/ibos/monitor.png" alt="">
                            <p>实时监控</p>
                            <p>该系统能够实时监控建筑设施的运行状态，包括照明设备、安防设备、能耗情况等，帮助管理者及时掌握建筑内部情况。
                            </p>
                        </div>
                    </div>

                    <div class="bottom">
                        <div>
                            <img src="../../../assets/solution/ibos/list.png" alt="">
                            <p>高效能耗管理</p>
                            <p>IBOS系统通过能耗监测和优化调整，帮助管理者提高能源利用效率，降低能耗成本。
                            </p>
                        </div>
                        <div>
                            <img src="@/assets/solution/ibos/safety.png" alt="">
                            <p>安全保障</p>
                            <p>系统集成了安防监控和门禁管理功能，能够实现对建筑安全的实时监测和权限控制，保障建筑及其用户的安全。
                            </p>
                        </div>
                    </div>


                </div>

            </div>
            <div class="function">
                <div class="left" ref="text">
                    <h1>功能说明</h1>
                    <div>
                        <h2>智能照明</h2>
                        <p>
                            智能照明管理实现对室内照明状态的监测和控制,通过面板、情景和区域设置来实现灯光的集中智能控制。</p>
                    </div>
                    <div>
                        <h2>安防监控</h2>
                        <p>
                            安防监控管理使用网络摄像头进行实时监控,支持云台控制和录像回放;还可以连接各类安防报警设备实现联动。</p>
                    </div>
                    <div>
                        <h2>门禁管理</h2>
                        <p> 门禁管理模块实现对出入口的锁控管理,可以按区域、门和人员等多维度配置门禁权限,记录通行日志,方便统计。
                        </p>
                    </div>
                    <div>
                        <h2>智慧能耗</h2>
                        <p>
                            智慧能耗管理实现用能监测,通过能耗概览、能耗统计等报表,分析建筑物的能源使用情况,为节能提供支撑。</p>
                    </div>
                    <div>
                        <h2>区域管理</h2>
                        <p>
                            区域管理系统通过数字化平台整合管理建筑或场地的各项服务。用户可以对不同区域进行灵活管理，包括设备控制、服务调度、人员流动等，提高整体运营效率。</p>
                    </div>
                    <div>
                        <h2>报事报修</h2>
                        <p>
                            报事报修系统允许用户快速报告建筑设备的问题，提供一个数字平台用于问题报告、维修任务分配和执行。管理员可以及时响应报修请求，提高建筑设备的可靠性和用户满意度。</p>
                    </div>
                    <div>
                        <h2>巡更巡检</h2>
                        <p>
                            巡更巡检系统通过数字化工具和移动设备，提供对特定区域的巡检计划和执行。巡检员可以按计划巡检各个巡检点，记录状态、完成任务，同时系统提供数据分析和历史记录，用于优化安全管理和设备运行。</p>
                    </div>
                    <div>
                        <p>
                            此外,星筑IBOS系统还提供强大的用户与组织权限配置,以及场景联动等智能化功
                            能。硬件方面,接入各类智能传感器、调光设备等,实现智慧楼宇的精细化管理。
                            该系统应用灵活,既能为智慧写字楼提供办公安防、能效和舒适度管理,同时也可应用于园区、酒店、商场等场景,实现对设施设备和能源的智能化集中管理。</p>
                    </div>

                </div>
                <div class="right" ref="img">
                    <div>
                        <img src="@/assets/solution/ibos/ibos1.png" alt="">
                        <img src="@/assets/solution/ibos/ibos2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div class="ibos">
                <div class="text animate__animated animate__fadeInLeft">
                    <p class="title">07 <span>星筑IBOS系统</span></p>
                    <p>
                        星筑IBOS系统是一款全面的智慧建筑管理系统，为现代化园区和建筑提供高效、智能的综合管理解决方案。通过集成智能照明、安防监控、智慧停车、状态监测、门禁管理、智慧能耗管理等功能，IBOS系统使建筑管理者能够实时监控和智能化管理建筑设施。借助先进的物联网技术和大数据分析，该系统提供全面的实时监测、预警和优化调节能力，助力建筑实现更高效、更安全、更可持续的运营管理。</p>
                </div>
                <div class="image animate__animated animate__fadeInRight">
                    <img src="../../../assets/solution/ibos/ibos.png" alt="">
                    <p>IBOS驾驶舱页面</p>
                </div>
            </div>
            <div class="features">
                <div class="title">
                    <p>产品特点</p>
                    <p>PRODUCT FEATURES</p>
                </div>
                <div class="main">
                    <div>
                        <img src="../../../assets/solution/ibos/totality.png" alt="">
                        <div>
                            <p>全面性</p>
                            <p>IBOS系统涵盖了智能照明、安防监控、智慧停车、状态监测、门禁管理、智慧能耗管理等多个功能，提供综合的建筑物管理解决方案。
                            </p>
                        </div>
                    </div>
                    <div>
                        <img src="../../../assets/solution/ibos/intelligent.png" alt="">
                        <div>
                            <p>智能化</p>
                            <p>借助物联网技术和大数据分析，IBOS系统实现了实时监测、预警和优化调节能力，使建筑管理更加智能化。
                            </p>
                        </div>
                    </div>
                    <div>
                        <img src="../../../assets/solution/ibos/monitor.png" alt="">
                        <div>
                            <p>实时监控</p>
                            <p>该系统能够实时监控建筑设施的运行状态，包括照明设备、安防设备、能耗情况等，帮助管理者及时掌握建筑内部情况。
                            </p>
                        </div>
                    </div>
                    <div>
                        <img src="../../../assets/solution/ibos/list.png" alt="">
                        <div>
                            <p>高效能耗管理</p>
                            <p>IBOS系统通过能耗监测和优化调整，帮助管理者提高能源利用效率，降低能耗成本。
                            </p>
                        </div>
                    </div>
                    <div>
                        <img src="@/assets/solution/ibos/safety.png" alt="">
                        <div>
                            <p>安全保障</p>
                            <p>系统集成了安防监控和门禁管理功能，能够实现对建筑安全的实时监测和权限控制，保障建筑及其用户的安全。
                            </p>
                        </div>
                    </div>


                </div>

            </div>
            <div class="function">
                <div class="left" ref="text">
                    <h1>功能说明</h1>
                    <div>
                        <h2>智能照明</h2>
                        <p>
                            智能照明管理实现对室内照明状态的监测和控制,通过面板、情景和区域设置来实现灯光的集中智能控制。</p>
                    </div>
                    <div>
                        <h2>安防监控</h2>
                        <p>
                            安防监控管理使用网络摄像头进行实时监控,支持云台控制和录像回放;还可以连接各类安防报警设备实现联动。</p>
                    </div>
                    <div>
                        <h2>门禁管理</h2>
                        <p> 门禁管理模块实现对出入口的锁控管理,可以按区域、门和人员等多维度配置门禁权限,记录通行日志,方便统计。
                        </p>
                    </div>
                    <div>
                        <h2>智慧能耗</h2>
                        <p>
                            智慧能耗管理实现用能监测,通过能耗概览、能耗统计等报表,分析建筑物的能源使用情况,为节能提供支撑。</p>
                    </div>
                    <img src="@/assets/solution/ibos/ibos1.png" alt="">
                    <div>
                        <h2>区域管理</h2>
                        <p>
                            区域管理系统通过数字化平台整合管理建筑或场地的各项服务。用户可以对不同区域进行灵活管理，包括设备控制、服务调度、人员流动等，提高整体运营效率。</p>
                    </div>
                    <div>
                        <h2>报事报修</h2>
                        <p>
                            报事报修系统允许用户快速报告建筑设备的问题，提供一个数字平台用于问题报告、维修任务分配和执行。管理员可以及时响应报修请求，提高建筑设备的可靠性和用户满意度。</p>
                    </div>
                    <div>
                        <h2>巡更巡检</h2>
                        <p>
                            巡更巡检系统通过数字化工具和移动设备，提供对特定区域的巡检计划和执行。巡检员可以按计划巡检各个巡检点，记录状态、完成任务，同时系统提供数据分析和历史记录，用于优化安全管理和设备运行。</p>
                    </div>
                    <img src="@/assets/solution/ibos/ibos2.png" alt="">
                    <div>
                        <p>
                            此外,星筑IBOS系统还提供强大的用户与组织权限配置,以及场景联动等智能化功
                            能。硬件方面,接入各类智能传感器、调光设备等,实现智慧楼宇的精细化管理。
                            该系统应用灵活,既能为智慧写字楼提供办公安防、能效和舒适度管理,同时也可应用于园区、酒店、商场等场景,实现对设施设备和能源的智能化集中管理。</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IBOS',
    data() {
        return {
            scrollTop: 0,
            pageWidth: window.innerWidth
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => {
            const text = this.$refs.text;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        text.classList.add('animate__animated', 'animate__fadeInLeft');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(text);
        })
        this.$nextTick(() => {
            const img = this.$refs.img;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        img.classList.add('animate__animated', 'animate__fadeInRight');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(img);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../styles/intelligent/ibos";

</style>
